// ABOUTME: The one localStorage access path: typed keys from storageKeys, JSON in and out,
// ABOUTME: and no exceptions — storage that is missing, full or blocked reads as empty.

import type { StorageKey } from "../constants/storageKeys"

export const storageService = {
  /** Parsed JSON, or null when the key is absent, the JSON is corrupt or storage throws. */
  get<T>(key: StorageKey): T | null {
    try {
      const item = localStorage.getItem(key)
      if (item === null) return null
      return JSON.parse(item) as T
    } catch {
      return null
    }
  },

  getString(key: StorageKey): string | null {
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  },

  set<T>(key: StorageKey, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // full quota or private mode — the value lives on in memory only
    }
  },

  setString(key: StorageKey, value: string): void {
    try {
      localStorage.setItem(key, value)
    } catch {
      // full quota or private mode — the value lives on in memory only
    }
  },

  remove(key: StorageKey): void {
    try {
      localStorage.removeItem(key)
    } catch {
      // storage blocked — nothing to remove
    }
  },
}
